import AuthService from './authService';
import BasketService from './basketService';
import CultureService from './cultureService';
import FilterDetector from './filterDetector';
import L10nService from './l10nService';
import LocaleService from './locale-service';
import LocationService from './location-service';
import SessionService from './sessionService';
import UserService from './userService';
import TimeService from './timeService';
import StaticDataGetter from './static-data-getter';
import MapsService from './maps-service';
import GoogleMapsService from './google-maps-service/google-maps-service';
import ThemesService from './themes-service';

const MODULE_NAME = 'App.Services';
const module = angular
    .module(MODULE_NAME, [
        'ipCookie',
        'LocalStorageModule',
    ])
    .service('authService', AuthService)
    .service('basketService', BasketService)
    .service('cultureService', CultureService)
    .service('filterDetector', FilterDetector)
    .service('l10nService', L10nService)
    .service('localeService', LocaleService)
    .service('locationService', LocationService)
    .service('sessionService', SessionService)
    .service('mapsFactory', MapsService)
    .service('timeService', TimeService)
    .service('staticDataGetter', StaticDataGetter)
    .service('userService', UserService)
    .service('googleMapsService', GoogleMapsService)
    .service('themesService', ThemesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/services/services-module.js